// extracted by mini-css-extract-plugin
export var bubbleFadeIn = "persistent-chat-module--bubbleFadeIn--d3d66";
export var chatBody = "persistent-chat-module--chatBody--d86e7";
export var chatBubble = "persistent-chat-module--chatBubble--0a802";
export var chatBubbleClose = "persistent-chat-module--chatBubbleClose--d8548";
export var chatButton = "persistent-chat-module--chatButton--0e8b4";
export var chatButtonOpen = "persistent-chat-module--chatButtonOpen--103aa";
export var chatClose = "persistent-chat-module--chatClose--6253b";
export var chatContainer = "persistent-chat-module--chatContainer--317d7";
export var chatHeader = "persistent-chat-module--chatHeader--a6115";
export var chatPanel = "persistent-chat-module--chatPanel--0106e";
export var chatPanelOpen = "persistent-chat-module--chatPanelOpen--355eb";
export var chatTitle = "persistent-chat-module--chatTitle--a6549";
export var morph = "persistent-chat-module--morph--b5652";
export var pulse = "persistent-chat-module--pulse--5ea9d";
export var wave = "persistent-chat-module--wave--9991b";